import { render, staticRenderFns } from "./Vcard.vue?vue&type=template&id=f6e3abe6&scoped=true&"
import script from "./Vcard.vue?vue&type=script&lang=js&"
export * from "./Vcard.vue?vue&type=script&lang=js&"
import style0 from "./Vcard.vue?vue&type=style&index=0&id=f6e3abe6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e3abe6",
  null
  
)

export default component.exports